import { render, staticRenderFns } from "./PcGraphHotkeys.vue?vue&type=template&id=33abf3e2"
import script from "./PcGraphHotkeys.vue?vue&type=script&lang=js"
export * from "./PcGraphHotkeys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports